import { useState } from "react";
import emailjs from "emailjs-com";
import React from "react";

const initialState = {
  name: "",
  email: "",
  message: "",
};
export const Contact = (props) => {
  const [{ name, email, message }, setState] = useState(initialState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };
  const clearState = () => setState({ ...initialState });


  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(name, email, message);

    {/* replace below with your own Service ID, Template ID and Public Key from your EmailJS account */ }

    emailjs
      .sendForm("YOUR_SERVICE_ID", "YOUR_TEMPLATE_ID", e.target, "YOUR_PUBLIC_KEY")
      .then(
        (result) => {
          console.log(result.text);
          clearState();
        },
        (error) => {
          console.log(error.text);
        }
      );
  };
  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-5 col-xs-12">
            <div className="row">
              <div className="section-title">
                <h2>联系我们</h2>
                <p>
                  留言后专员会尽快联系您。
                </p>
              </div>
              <form name="sentMessage" validate onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder="姓名"
                        required
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="电话或邮箱"
                        required
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    className="form-control"
                    rows="4"
                    placeholder="留言"
                    required
                    onChange={handleChange}
                  ></textarea>
                  <p className="help-block text-danger"></p>
                </div>
                <div id="success"></div>
                <button type="submit" className="btn btn-custom btn-lg">
                  发送
                </button>
              </form>
            </div>
          </div>
          <div className="col-md-7 col-xs-12  contact-info">
            <div className="col-md-12">
              <h3>联系信息</h3>

            </div>
            <div className="col-md-12">

              <div className="col-md-8 col-xs-12">
                <div className="contact-item">
                  <p >
                    <span>
                      <i className="fa fa-map-marker"></i> 地址
                    </span>
                    {props.data ? props.data.address : "loading"}
                  </p>
                </div>
                <div className="contact-item">
                  <p style={{
                    whiteSpace: 'pre-line'
                  }}>
                    <span>
                      <i className="fa fa-phone"></i> 电话
                    </span>{" "}
                    {props.data ? props.data.phone : "loading"}
                  </p>
                </div>
                <div className="contact-item">
                  <p>
                    <span>
                      <i className="fa fa-envelope-o"></i> 邮箱
                    </span>{" "}
                    {props.data ? props.data.email : "loading"}
                  </p>
                </div>
              </div>
              <div className="col-md-4 col-xs-12 text-center">
                {/*<img 
                src={props.data?.attacheCode ? props.data.attacheCode : ""} 
                alt="二维码" 
                className="img-responsive qrcode text-center" 
                
                width={'70%'}></img>
                <p>公众号</p>*/}
                <img src={props.data?.officalCode ? props.data.officalCode : ''} alt="二维码" className="img-responsive qrcode" width={'100%'}></img>
                <p>专员微信</p>

              </div>
            </div>
          </div>


        </div>
      </div>

    </div>
  );
};
